export const Role = {
  Admin: 1,
  ManagerMovile: 2,
  ManagerAccesory: 3,
  Seller: 4,
  GuaranteeHelper: 5,
};
